/**
 * Format currency amount without decimals
 * Rounds to nearest integer to avoid floating point issues
 * @param amount - The amount to format
 * @returns Formatted string like "Ksh 5000"
 */
export function formatCurrency(amount: number | string | null | undefined): string {
    if (amount === null || amount === undefined || amount === '') {
        return 'Ksh 0';
    }

    // Convert to number and round to avoid floating point issues
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    if (isNaN(numAmount)) {
        return 'Ksh 0';
    }

    // Round to nearest integer
    const rounded = Math.round(numAmount);

    // Format with thousand separators but no decimals
    return `Ksh ${rounded.toLocaleString('en-US')}`;
}

/**
 * Format currency amount for display in tables/cards (without Ksh prefix)
 * @param amount - The amount to format
 * @returns Formatted string like "5,000"
 */
export function formatAmount(amount: number | string | null | undefined): string {
    if (amount === null || amount === undefined || amount === '') {
        return '0';
    }

    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    if (isNaN(numAmount)) {
        return '0';
    }

    const rounded = Math.round(numAmount);
    return rounded.toLocaleString('en-US');
}

